import clothes from './clothes'
import grocery from './grocery'
import ingredients from './ingredients'
import { createOEM, updateOEM } from '@/apis/oem'
import store from '@/store'

declare interface T {
  label: string
  value: string | number
}
declare interface Tip {
  tooltip?: string
  tipOption?: any
}
export declare interface Option extends T {
  next: string
  tooltip?: string
  bridge?: string
}
export declare interface Branch {
  type: 'BranchOption'
  title: string
  key: string
  options: Option[]
  long?: boolean
}
const nodes: any = {
  1: (): Branch => {
    const m:any = store.state.route.user?.membership
    const tooltip = '如果您想定制其他复杂产品，比如服饰杂货等，请升级商务舱，我们会有专门的客户经理单独一对一和您对接。'
    return {
      type: 'BranchOption',
      title: '您想要一个什么类型的商品？',
      key: 'questionClassificationName',
      options: m.templateLevel === 1 ? [
        { label: '辅料', value: 'C', next: '13', tooltip }
      ] : [
        { label: '服装', value: 'A', next: '11' },
        { label: '杂货', value: 'B', next: '12' },
        { label: '辅料', value: 'C', next: '13' }
      ]
    }
  },
  // 服装
  ...clothes,
  // 杂货
  ...grocery,
  // 辅料
  ...ingredients,
  // 需求描述模板
  2: (prev: any, data: any) => {
    const isA = data.questionClassificationName === 'A'
    const label = isA ? '需求描述' : '补充说明'
    const tooltip = isA
      ? '请大致描述一下希望改动哪些方面,如:材质、设计、颜色、尺寸等'
      : '如果需要改动的点已经在式样书中完全展现，可以略过，否则可做补充说明'
    const next = isA ? '5' : 'B'
    return {
      type: 'InfoForm',
      title: '请详细说明您需要改动的地方',
      items: [
        {
          type: 'textarea',
          label,
          key: 'needChangeThings',
          tooltip
        },
        {
          type: 'file',
          label: '上传文件',
          key: 'needChangeThingsUrl'
        }
      ],
      next
    }
  },
  // 填写物流单号模板
  3: ({ bridge }: any) => {
    const next = bridge
    return {
      type: 'InfoForm',
      title: '请完善信息',
      items: [
        {
          type: 'text',
          label: '直行便地址',
          text: `
          中国語：浙江省杭州市滨江区阿里中心4幢7楼707室##
          英語：4-707, Ali Center,No. 1866, Binxing Road, Binjiang District, Hangzhou City, Zhejiang Province，China##
          〒： 310051##
          電話：+86-17805801210##
          受取人：株式会社SNIFF JAPAN
          `
        },
        {
          type: 'input',
          trim: true,
          label: '物流单号',
          key: 'logisticsNo',
          options: {
            maxlength: 50
          }
        }
      ],
      next
    }
  },
  // 面料色卡模板
  4: ({ bridge }: any) => {
    const next = bridge
    return {
      type: 'InfoForm',
      title: '请提供具体的色卡信息',
      items: [
        {
          type: 'input',
          label: '面料信息',
          key: 'fabricInfo',
          placeholder: '棉100%'
        },
        {
          type: 'color-card',
          label: '选择色卡',
          key: 'colorCard'
        }
      ],
      data: {
        colorCard: []
      },
      next
    }
  },
  // 是否有式样书
  5: (prev: any, data: any) => {
    const isA = data.questionClassificationName === 'A'
    const isADB =
      data.clothingQuestionInitialRequirement === 'D' &&
      data.clothingQuestionCanSendSample === 'B'
    const isB = data.questionClassificationName === 'B'
    const bridges = isA
      ? isADB
        ? ['112']
        : ['112', '112']
      : isB
        ? ['2', '1211']
        : []

    return {
      type: 'BranchOption',
      title: '请问您是否有式样书？',
      key: 'hasStyleBook',
      options: [
        {
          label: '有',
          value: 'A',
          next: '6',
          tooltip: '式样书必须包含产品的色卡、尺寸、特殊工艺、面料信息等',
          bridge: bridges[0]
        },
        {
          label: '没有',
          value: 'B',
          next: bridges[1] || '7'
        }
      ]
    }
  },
  // 上传式样书
  6: ({ bridge }: any) => {
    const next = bridge
    return {
      type: 'InfoForm',
      title: '请上传式样书',
      tooltip: '式样书必须包含产品的色卡、尺寸、特殊工艺、面料信息等',
      items: [
        {
          type: 'download',
          label: '式样书',
          tooltip: '请先下载对应模板，填写完成后上传',
          list: [
            {
              text: '式样书(例)',
              url: 'https://theckbs-oss.theckbs.com/customer/header/yjptufn.pdf'
            },
            {
              text: '模板下载',
              url: 'https://theckbs-oss.theckbs.com/customer/header/ydhqxu0.xlsx'
            }
          ]
        },
        {
          type: 'file',
          label: '上传文件',
          key: 'stylebookUrl'
        }
      ],
      next
    }
  },
  // 无法寻源
  7: () => {
    return {
      type: 'InfoForm',
      title: '由于信息不足，直行便暂时无法为您提供寻源服务',
      url: 'https://theckbs-oss.theckbs.com/customer/header/ydhqxu0.xlsx',
      fail: true
    }
  },
  // 填写产品信息模板
  8: (prev: any, data: any) => {
    const next = data.questionClassificationName === 'A' ? '111' : '9'
    // todo: 带入sku
    return {
      type: 'InfoForm',
      title: '请填写你想定制产品的基本信息',
      items: [
        {
          type: 'input',
          options: {
            maxlength: '128'
          },
          label: '产品名称',
          key: 'productName'
        },
        {
          type: 'image',
          label: '图片',
          key: 'productImg'
        },
        {
          type: 'input',
          label: '参考链接',
          key: 'productUrl',
          options: {
            maxlength: 200
          }
        },
        {
          type: 'add-sku',
          label: '产品信息',
          key: 'searchSourceOrderSkuList',
          tooltip:
            '请填写商品的尺寸分类。如果有多个大小，请添加行并输入大小。例M、L、XL、30cm*40cm*20cm等',
          tipOption: {
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [43, 25]
                  }
                }
              ]
            }
          }
        },
        {
          type: 'textarea',
          label: '其他补充',
          key: 'productInfoSupplement'
        }
      ],
      data: {
        searchSourceOrderSkuList: []
      },
      next
    }
  },
  // 填写下单需求模板
  9: (prev: any, data: any) => {
    const isB = data.questionClassificationName === 'B'
    const next = isB ? 'D' : 'A'
    const logo = isB
      ? []
      : [{ type: 'image', label: '是否需要加logo', key: 'logoUrl' }]
    return {
      type: 'InfoForm',
      title: '请输入产品的下单需求',
      tooltip:
        '直行便的报价与希望起订量和价格是否匹配，是我们判定是否为您寻源成功的判断依据。请您客观的填写。如果您的希望和市场行情差异过大，我们会之后先联系您，提出修改建议，再开始为您寻源报价。',
      items: [
        {
          type: 'number',
          options: {
            precision: 2
          },
          unit: '元',
          label: '期望价格',
          key: 'customerExpectPrice'
        },
        {
          type: 'number',
          options: {
            stepStrictly: true
          },
          unit: '件',
          label: '期望最低起订量',
          key: 'customerExpectMinOrderQuantity'
        },
        ...logo,
        {
          type: 'date',
          label: '期望交期时间',
          key: 'customerExpectDeliveryTime',
          options: {
            disabledDate: (date: Date) => date.getTime() < Date.now()
          }
        },
        {
          type: 'checkbox-group',
          label: '侧重点',
          key: 'customerFocus',
          list: [{ label: '价格' }, { label: '品质' }, { label: '交期' }]
        },
        {
          type: 'textarea',
          label: '其他补充',
          key: 'orderDemandSupplement'
        }
      ],
      data: {
        customerFocus: []
      },
      next
    }
  },
  // 备注并创建
  A: () => {
    return {
      type: 'InfoForm',
      title: '寻源备注',
      items: [
        {
          type: 'textarea',
          wide: true,
          options: {
            autosize: {
              minRows: 6
            }
          },
          label: '如果您对本次寻源还有其他特殊需求，请在以下输入您的需求',
          key: 'remark'
        }
      ],
      end: true,
      next: 'F'
    }
  },
  // 是否附加Logo
  B: (prev: any) => {
    return {
      type: 'BranchOption',
      title: '请问您需要附加Logo吗？',
      key: 'isAppendLogo',
      options: [
        {
          label: '需要',
          value: 'A',
          next: 'C',
          bridge: '8'
        },
        {
          label: '不需要',
          value: 'B',
          next: '8'
        }
      ]
    }
  },
  // 上传Logo
  C: ({ bridge }: any) => {
    const next = bridge
    return {
      type: 'InfoForm',
      title: '请完善Logo信息',
      items: [
        {
          type: 'image',
          label: '上传图片',
          key: 'logoUrl'
        },
        {
          type: 'textarea',
          label: '附加说明',
          key: 'logoDetailDesc',
          tooltip: '请对logo颜色、尺寸、工艺、位置做说明'
        }
      ],
      next
    }
  },
  // 产品资质特殊要求
  D: () => {
    return {
      type: 'InfoForm',
      title: '请问您对本次寻源的工厂或产品资质有特殊要求吗？',
      items: [
        {
          type: 'textarea',
          wide: true,
          placeholder: '指定工場',
          tooltip: '资质要求例子',
          options: {
            autosize: {
              minRows: 6
            }
          },
          label: '资质要求',
          key: 'qualificationRequirement'
        }
      ],
      next: 'A'
    }
  },
  F: async (prev: any, data: any, records: any): Promise<any> => {
    data = JSON.parse(JSON.stringify(data))
    if (data.colorCard) {
      data.colorCard = data.colorCard.map((v: any) => v.code)
    }
    const questionRecord = JSON.stringify(records)
    data.questionRecord = questionRecord
    //
    ;[
      'ingredientsMaterialsId',
      'ingredientsSizeId',
      'ingredientsStyleId'
    ].forEach((key: any) => {
      if (data[key] === 'custom') {
        delete data[key]
      }
    })
    data.customerFocus = (data.customerFocus ?? []).join()
    const api = data.searchSourceOrderId ? updateOEM : createOEM

    await api(data).then((res: any) => {
      console.log(res)
    })
    return {
      type: 'CompleteQuest',
      success: true,
      finish: true
    }
  }
}
export default async (id: string, ...rest: any): Promise<any> => {
  return Object.assign({ id, data: {} }, await nodes[id](...rest))
}
